import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { DomSanitizer,SafeResourceUrl } from '@angular/platform-browser';
import { NgxSpinnerService } from 'ngx-spinner';
import { ComponentService } from '../../services/component.service';

@Component({
  selector: 'app-nica-help-n-doc',
  templateUrl: './nica-help-n-doc.component.html',
  styleUrls: ['./nica-help-n-doc.component.css']
})
export class NicaHelpNDocComponent implements OnInit {


  srlHelp: string;   // Richiama il service per costrure la form
  showHelpFrame:boolean=false
  urlEmbedHelp: SafeResourceUrl;
  fullScreen:boolean
  posY: any;
  posX: any;
  left:any;
  top:any;
  altezza:any;
footer:boolean=false
  constructor(private componentService: ComponentService, private sanitizer: DomSanitizer, private load:NgxSpinnerService, private cdr:ChangeDetectorRef) { }

  ngOnInit() {
   
    this.componentService.helpNDoc.subscribe(res=>{

      this.footer=res['isFooter']||false
        this.showHelpFrame = res['enableShow'];
        this.srlHelp = res['url'] +'?random=' + (new Date()).getTime() + Math.floor(Math.random() * 1000000);
      
        this.urlEmbedHelp = this.sanitizer.bypassSecurityTrustResourceUrl(this.srlHelp)
     
    })
   
    

  }
  showingPopUp(e) {
  
    var w = 1064;
    var h = 800;
    this.altezza=window.top.outerHeight-100
    this.posY = window.top.outerHeight / 2 + window.top.screenY - (h / 2);
    this.posX = window.top.outerWidth / 2 + window.top.screenX - (w / 2);
    this.left = (screen.width / 2) - (w / 2);
    this.top = (screen.height / 2) - (h / 2);



      e.component.content().parentNode.classList.add("formEditPopup"); //add class to overlay content
      e.component.content().classList.add("formEditPopupContet"); //add class to content
      e.component.content().classList.add("bg-grey"); //add class to content;
      
      e.component.content().parentNode.classList.add("formPopup"); //add class to overlay content
      e.component.content().classList.add("pippo"); //add class to content;
this.cdr.detectChanges();

  }

  hidePopUpHelp(ev){
    let data={
      url:null,
      enableShow:false
    }

      this.componentService.enableHelpNDoc(data);
      this.showHelpFrame = false;
      this.srlHelp = ''
      this.fullScreen=false
      
  }

  fullscreen(ev){
   this.fullScreen = !this.fullScreen
  }
}
